export default __webpack_public_path__ + "static/media/see-you-again.4dd3b634.jpg";